var exports = {
  "K": "xaf9ae18d--853340--icon",
};

module.exports = exports;
